module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "rtitle flex justify-between align-center bg-white rone"
  }, [_c('div', {
    staticClass: "colorleft"
  }, [_vm._v("服务记录")]), _vm._v(" "), _c('div', {
    staticClass: "colorright"
  }, [_vm._v("共" + _vm._s(_vm.totalnumnew ? _vm.totalnumnew : 0) + "条")])]), _vm._v(" "), _c('div', {
    staticClass: "cball"
  }, [_c('div', [(_vm.zlist.length) ? _c('div', {
    staticClass: "flex justify-between aling-center flex-wrap",
    staticStyle: {
      "min-height": "570px"
    }
  }, _vm._l((_vm.zlist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "bg-white",
      staticStyle: {
        "width": "487px",
        "border-radius": "12px",
        "margin-bottom": "10px"
      }
    }, [_c('div', {
      staticStyle: {
        "padding": "30px",
        "border-bottom": "1px solid #eee"
      }
    }, [_c('div', {
      staticClass: "flex justify-center align-center lastone"
    }, [_c('div', {
      staticStyle: {
        "width": "100px",
        "color": "#151515",
        "font-size": "18px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t服务类型\n\t\t\t\t\t\t\t")]), _vm._v(" "), (item.type == 1) ? _c('div', {
      staticClass: "flex-sub",
      staticStyle: {
        "color": "#838383",
        "font-size": "18px"
      }
    }, [_vm._v("技术服务\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (item.type == 2) ? _c('div', {
      staticClass: "flex-sub",
      staticStyle: {
        "color": "#838383",
        "font-size": "18px"
      }
    }, [_vm._v("创业服务\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (item.type == 3) ? _c('div', {
      staticClass: "flex-sub",
      staticStyle: {
        "color": "#838383",
        "font-size": "18px"
      }
    }, [_vm._v("租赁服务\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (item.type == 4) ? _c('div', {
      staticClass: "flex-sub",
      staticStyle: {
        "color": "#838383",
        "font-size": "18px"
      }
    }, [_vm._v("培训服务\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (item.type == 5) ? _c('div', {
      staticClass: "flex-sub",
      staticStyle: {
        "color": "#838383",
        "font-size": "18px"
      }
    }, [_vm._v("孵化服务\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (item.type == 6) ? _c('div', {
      staticClass: "flex-sub",
      staticStyle: {
        "color": "#838383",
        "font-size": "18px"
      }
    }, [_vm._v("入驻企业\n\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "flex justify-center align-center lastone"
    }, [_c('div', {
      staticStyle: {
        "width": "100px",
        "color": "#151515",
        "font-size": "18px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t咨询时间\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "flex-sub",
      staticStyle: {
        "color": "#838383",
        "font-size": "18px"
      }
    }, [_vm._v(_vm._s(item.createtime))])]), _vm._v(" "), _c('div', {
      staticClass: "flex justify-center align-center lastone"
    }, [_c('div', {
      staticStyle: {
        "width": "100px",
        "color": "#151515",
        "font-size": "18px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t咨询状态\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "flex-sub",
      staticStyle: {
        "font-size": "18px"
      }
    }, [(item.status == 0) ? _c('span', {
      staticStyle: {
        "color": "#ffa800"
      }
    }, [_vm._v("未处理")]) : _vm._e(), _vm._v(" "), (item.status == 1) ? _c('span', {
      staticStyle: {
        "color": "#0fc4ad"
      }
    }, [_vm._v("处理中")]) : _vm._e(), _vm._v(" "), (item.status == 2) ? _c('span', {
      staticStyle: {
        "color": "#0055ff"
      }
    }, [_vm._v("已办结")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "22px 30px"
      }
    }, [_c('div', {
      staticStyle: {
        "color": "#151515",
        "font-size": "18px",
        "margin-bottom": "15px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t服务内容\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "text-cut2",
      staticStyle: {
        "padding": "15px 20px",
        "background-color": "#f5f5f5"
      }
    }, [_c('div', {
      staticClass: "text-cut2",
      staticStyle: {
        "min-height": "64px",
        "color": "#b6b5b5",
        "font-size": "18px",
        "line-height": "32px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.content) + "\n\t\t\t\t\t\t\t")])]), _vm._v(" "), (item.detail) ? [_c('div', {
      staticStyle: {
        "color": "#151515",
        "font-size": "18px",
        "margin": "15px 0"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t回复内容\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "text-cut2",
      staticStyle: {
        "padding": "15px 20px",
        "background-color": "#f5f5f5"
      }
    }, [_c('div', {
      staticClass: "text-cut2",
      staticStyle: {
        "min-height": "64px",
        "color": "#b6b5b5",
        "font-size": "18px",
        "line-height": "32px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(item.detail) + "\n\t\t\t\t\t\t\t\t")])])] : _vm._e(), _vm._v(" "), (item.file) ? [_c('div', {
      staticStyle: {
        "color": "#151515",
        "font-size": "18px",
        "margin": "15px 0"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t回复附件\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "text-cut2",
      staticStyle: {
        "padding": "10px 20px"
      }
    }, [_c('a', {
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "color": "#b6b5b5",
        "text-decoration": "none"
      },
      attrs: {
        "target": "_blank",
        "href": _vm._f("addurl")(item.file)
      }
    }, [_c('img', {
      staticStyle: {
        "width": "40px",
        "height": "40px",
        "margin-right": "10px"
      },
      attrs: {
        "src": require("../../../static/assets/images/wenjian.png")
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t点击打开\n\t\t\t\t\t\t\t\t")])])] : _vm._e()], 2)])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.zlist.length && !_vm.load) ? _c('div', {
    staticClass: " bg-white",
    staticStyle: {
      "min-height": "480px",
      "padding": "40px"
    }
  }, [_c('el-empty', {
    attrs: {
      "description": "暂无数据"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "pager-count": _vm.pagerCount,
      "hide-on-single-page": true,
      "page-size": _vm.pagesize,
      "current-page": _vm.currentPagenew,
      "total": _vm.totalnumnew
    },
    on: {
      "size-change": _vm.handleSizeChangenew,
      "current-change": _vm.handleCurrentChangenew
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b0a80f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mine/service_list.vue
// module id = 387
// module chunks = 1